import * as React from 'react';
import { Route, Switch} from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as AuthCreators from './creators/auth';
import isLogined from './selectors/isLogined$';
import PreLoader from './components/PreLoader/PreLoader';

import Home from './containers/Home/Home';
import Auth from './modules/Auth/Auth';
import MapWrapper from './components/Map/MapWrapper';
import './styles/app.scss';

class App extends React.Component {

  componentDidMount(){
    if(this.props.isLogined){
      const firstPage = true;
      this.props.fetchRefreshAuth(firstPage);
    }
  }

  addRoute = (path, component) => {
    return (
      <Route
        exact
        path={path}
        component={component} />
    );
  }

  renderPrivateRoutes() {
    return (
      <Switch>
        {this.addRoute('/', Home)}
        {this.addRoute('/map', MapWrapper)}
        {this.props.isLogined ?  null : this.renderPublicRoutes()}
      </Switch>
    );
  }

  renderPublicRoutes(){
    return(
      <Switch>
        {this.addRoute('*', Auth)}
        {this.props.isLogined ?  this.renderPrivateRoutes() : null}
      </Switch>
    );
  }

  render() {
    return (
      <div className='app-container container'>
        {this.props.initLoading ? <PreLoader /> : null }
        { this.props.isLogined ? 
          <div style={{height: '100%'}}>
            {this.renderPrivateRoutes()}
          </div> :
          this.renderPublicRoutes()
        }
      </div>
    );
  }
}

App.propTypes = {
  initLoading: PropTypes.bool,
  isLogined: PropTypes.bool,
  appMounted: PropTypes.func,
  userInfo: PropTypes.object,
  location: PropTypes.object,
  fetchRefreshAuth: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    initLoading: state.auth.initLoading,
    isLogined: isLogined(state),
    isError: state.auth.isError,
  };
};

const mergeProps = (stateProps, dispatchProps, props) => {
  return {
    ...stateProps,
    appMounted: dispatchProps.appMounted,
    fetchRefreshAuth: dispatchProps.fetchRefreshAuth,
    ...props
  };
};

export default connect(
  mapStateToProps, {
    appMounted: AuthCreators.appMounted,
    fetchRefreshAuth: AuthCreators.fetchRefreshAuth,
  },mergeProps
)(App);